export default {
	id: "iphone-7",
	title: "iPhone 7",
	company: "Apple",
	borderRadius: "0.1em",
	colorSide: true,
	styles: [
		{
			title: "normal",
			pos: ["12%", "7%", "12.5%", "7%"],
			colors: [
				{title: "Gold", hex: "#DBC5AB", img: require("./original/gold.png")},
				{
					title: "Rose Gold",
					hex: "#f7d0cb",
					img: require("./original/rosegold.png")
				},
				{
					title: "Silver",
					hex: "#D5D2CF",
					img: require("./original/silver.png")
				},
				{
					title: "Jet Black",
					hex: "#050002",
					img: require("./original/jetblack.png")
				},
				{title: "Black", hex: "#000000", img: require("./original/black.png")}
			]
		},
		{
			title: "flat",
			pos: ["12%", "6.6%", "12.5%", "6.6%"],
			colors: [
				{title: "Gold", hex: "#DBC5AB", img: require("./flat/gold.svg")},
				{
					title: "Rose Gold",
					hex: "#f7d0cb",
					img: require("./flat/rosegold.svg")
				},
				{title: "Silver", hex: "#D5D2CF", img: require("./flat/silver.svg")},
				{
					title: "Jet Black",
					hex: "#050002",
					img: require("./flat/jetblack.svg")
				},
				{title: "Black", hex: "#000000", img: require("./flat/black.svg")}
			]
		}
	]
};
